import React, { useState } from "react";
import { motion, useAnimation } from "framer-motion";

const logos = [
  "/assets/salesforce-header.png",
  "/assets/hubspot-header.png",
  "/assets/zoho-header.png",
  "/assets/freshworks-header.png",
  "/assets/acquia-header.png",
  "/assets/mulesoft-header.png",
  "/assets/aws-header.png",
  "/assets/azure-header.png",
  "/assets/gcp-header.png",
];

const FooterLogo: React.FC = () => {
  const [isPaused, setIsPaused] = useState(false);
  const controls = useAnimation();

  React.useEffect(() => {
    if (isPaused) {
      controls.stop(); // Stop current animation
    } else {
      controls.start({
        x: [0, -100 * logos.length],
        transition: {
          x: {
            repeat: Infinity,
            repeatType: "loop",
            duration: 15,
            ease: "linear",
          },
        },
      });
    }
  }, [isPaused, controls]);

  return (
    <footer className="container-common overflow-hidden relative z-10">
      <div className="flex justify-center items-center overflow-hidden whitespace-nowrap">
        <motion.div
          className="flex"
          animate={controls}
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          {[...logos, ...logos].map((logo, index) => (
            <img
              src={`${process.env.PUBLIC_URL}${logo}`}
              alt={`logo-${index}`}
              key={index}
              loading="lazy"
              className="w-32 h-28 mx-8 object-contain"
            />
          ))}
        </motion.div>
      </div>
    </footer>
  );
};

export default FooterLogo;
